/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_other_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Andere Wege`
};

const en_other_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Other routes`
};

const es_other_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Otros itinerarios`
};

const fr_other_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Autres voies`
};

const it_other_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Altri percorsi`
};

const nl_other_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Andere routes`
};

const pt_other_roads = /** @type {(inputs: {}) => string} */ () => {
	return `Outras vias`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const other_roads = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.other_roads(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("other_roads", locale)
	if (locale === "de") return de_other_roads(inputs)
	if (locale === "en") return en_other_roads(inputs)
	if (locale === "es") return es_other_roads(inputs)
	if (locale === "fr") return fr_other_roads(inputs)
	if (locale === "it") return it_other_roads(inputs)
	if (locale === "nl") return nl_other_roads(inputs)
	return pt_other_roads(inputs)
};